import { useEffect } from 'react';
import { trackPageview } from 'analytics';

function useGA(_id, route) {
  useEffect(() => {
    // GA4 initialization handled in HTML; just track the page view.
    if (route) trackPageview(route);
  }, [route]);
}

export default useGA;
